import { FundingSource } from 'further-types/lp/investment';
import { FundingSourceLabels } from 'further-ui/labels';
import { numberToCurrencyString } from 'further-ui/utils';
import useVehicle from 'hooks/lp/data/vehicle/useVehicle';
import api from 'lib/trpcClient';

export default function useFundingSourceOptions(
  vehicleId: string,
  includeGeneralCapital = true,
  allowGeneralCapital = true,
) {
  const { data: generalCapital, isLoading } =
    api.capital.getGeneralCapital.useQuery({
      vehicleId,
    });

  const { vehicle } = useVehicle(vehicleId);

  let generalCapitalLabel =
    FundingSourceLabels[FundingSource.GeneralCapitalOnAccounts];

  if (includeGeneralCapital) {
    generalCapitalLabel =
      generalCapitalLabel +
      ` (${numberToCurrencyString(generalCapital?.amount ?? 0, {
        currency: vehicle?.baseCurrency,
      })})`;
  }
  const options = [
    ...(allowGeneralCapital
      ? [
          {
            value: FundingSource.GeneralCapitalOnAccounts,
            label: generalCapitalLabel,
          },
        ]
      : []),
    {
      value: FundingSource.CapitalCall,
      label: FundingSourceLabels[FundingSource.CapitalCall],
    },
  ];

  return { options, isLoading };
}
